<script setup lang="ts">
import ConsultationsTariffs from './ConsultationsTariffs.vue'
import OnlineTeachingTariffs from './OnlineTeachingTariffs.vue'

interface TariffsContext {
  general: { id: number; [key: string]: unknown }
  online_teaching?: {
    visible: boolean
    accept_requests: boolean
    trial_price: number
    price_min: number
    price_max: number
    native_speaker: boolean
    using_pikimoni: boolean
    software: Array<{ id: number; name: string }>
    payment_methods: Array<{ name: string }>
    offer_id: number
  } | null
  tutor_offer?: {
    offer_id: number
    visible: boolean
    accept_requests: boolean
    consult_price?: number
    verbal_analysis_price?: number
    analysis_price?: number
    software: number[]
    payment_methods: number[]
    accepts_bonus?: boolean
  } | null
  tutor_software?: Array<{ id: number; name: string }>
  tutor_payment_methods?: Array<{ id: number; name: string }>
  [key: string]: unknown
}

defineProps<{
  context: TariffsContext
  isCurrentUser: boolean
}>()
</script>

<template>
  <div class="teacher-bio__tab teacher-bio__tab_tariffs">
    <OnlineTeachingTariffs :context="context" :is-current-user="isCurrentUser" />
    <ConsultationsTariffs v-if="context.tutor_offer" :context="context" :is-current-user="isCurrentUser" />
  </div>
</template>
